import { render, staticRenderFns } from "./ShortBio.vue?vue&type=template&id=1bbe2a7d&"
import script from "./ShortBio.vue?vue&type=script&lang=js&"
export * from "./ShortBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports